import { openBrowserAsync } from "expo-web-browser";
import { useCallback } from "react";

import { isNative } from "../constants";

export const useBrowser = (url: string) =>
  useCallback(() => {
    if (isNative) {
      openBrowserAsync(url);
      return;
    }

    const newWindow = window.open(url, "_blank", "noopener,noreferrer");

    if (newWindow) newWindow.opener = null;
  }, [url]);
